'use client';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  gap: 96px;

  @media (max-width: 1320px) {
    max-width: 936px;
    gap: 64px;
  }

  @media (max-width: 936px) {
    max-width: 618px;
    gap: 32px;
  }
`;

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 32px;
`;
